module.exports = __webpack_public_path__ + "static/img/kayi-logo.8cc3882.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/kayi-logo.png
// module id = njxU
// module chunks = 0